import React from 'react'
import Button from '../Button'

function CancelButton({ onClick }) {
  return (
    <Button
      // size={32}
      onClick={onClick}
      title="Закрити"
      fill="normal"
      theme="bounded"
    />
  )
}

export default CancelButton
